module.exports = __webpack_public_path__ + "img/1626867221445.0c9e1586.jpeg";